































import Vue, { PropType } from 'vue';
import moment from 'moment-timezone';

import { IQuote } from '@/models';
import ConfirmationDialog from '@/components/common/ConfirmationDialog.vue';

export default Vue.extend({
  name: 'QuoteValidityExpirationDialog',

  components: {
    ConfirmationDialog
  },

  props: {
    quote: {
      type: Object as PropType<IQuote>
    }
  },

  data() {
    return {
      dialog: false,

      // Declare the function type without implementation
      resolvePromise: null as
        | null
        | ((value: boolean | PromiseLike<boolean>) => void)
    };
  },

  methods: {
    confirm() {
      if (this.resolvePromise) {
        this.resolvePromise(true);
        this.dialog = false;
      }
    },

    cancel() {
      if (this.resolvePromise) {
        this.resolvePromise(false);
        this.dialog = false;
      }
    },

    open() {
      this.dialog = true;
      // Return a promise that resolves based on button clicks
      return new Promise<boolean>(resolve => {
        // Store the resolve function to be used later
        this.resolvePromise = resolve;
      });
    },

    /**
     * @public api
     */
    openIfQuoteExpired() {
      if (this.quote.isExpired()) {
        return this.open();
      }
      return new Promise<boolean>(resolve => resolve(true));
    }
  }
});
